var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('div',{staticClass:"cuenta"},[_c('h1',[_vm._v("Mis datos de facturación")])]),_c('div',{staticClass:"back"},[_c('router-link',{attrs:{"to":"/detalles"}},[_c('Back')],1)],1)]),_c('DatosFacturar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }